import React from "react";
import { Group } from "@mantine/core";
import DeleteSurveyActionIcon from "../elements/DeleteSurveyActionIcon";
import UpdateSurveyActionIcon from "../elements/UpdateSurveyActionIcon";
import ViewSurveyActionIcon from "../elements/ViewSurveyActionIcon";
import ExportSurveyButton from "../elements/ExportSurveyButton";

type SurveyTableMenuProps = {
  id: number;
  title: string;
  status: string;
};

const editableStatuses = ["draft"];

const SurveyTableMenu: React.FC<SurveyTableMenuProps> = ({ id, title, status }) => (
  <Group>
    {editableStatuses.includes(status) ? (
      <>
        <UpdateSurveyActionIcon id={id} />
        <DeleteSurveyActionIcon id={id} />
      </>
    ) : (
      <>
        <ViewSurveyActionIcon id={id} title={title} />
        <ExportSurveyButton id={id} asButton={false}/>
      </>
    )}
  </Group>
);

export default SurveyTableMenu;
